import { store } from "@/store/store";
import { mantenimiento_permiso } from "@/shared/dtos/mantenimiento_permiso";
import {
  VuexModule,
  Mutation,
  getModule,
  Module,
  Action,
} from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({
  namespaced: true,
  name: "mantenimiento_permisoModule",
  store,
  dynamic: true,
})
class mantenimiento_permisoModule extends VuexModule {
  public mantenimiento_permisos: mantenimiento_permiso[] = [];
  public mantenimiento_permiso: mantenimiento_permiso = new mantenimiento_permiso();

  @Action({ commit: "onGetmantenimiento_permisos" })
  public async getmantenimiento_permisos() {
    return await ssmHttpService.get(API.mantenimiento_permiso);
  }

  @Action({ commit: "onGetmantenimiento_permiso" })
  public async getmantenimiento_permiso(id: any) {
    return await ssmHttpService.get(API.mantenimiento_permiso + "/" + id);
  }

  @Action
  public async guardarmantenimiento_permiso(
    mantenimiento_permiso: mantenimiento_permiso
  ) {
    /*toJson() no existe pero existe en la extends de BaseDto*/
    return await ssmHttpService.post(
      API.mantenimiento_permiso,
      mantenimiento_permiso.toJson()
    );
  }

  @Action
  public async modificarmantenimiento_permiso(
    mantenimiento_permiso: mantenimiento_permiso
  ) {
    return await ssmHttpService.put(
      API.mantenimiento_permiso + "/" + mantenimiento_permiso.id,
      mantenimiento_permiso
    );
  }

  @Action
  public async eliminarmantenimiento_permiso(
    mantenimiento_permiso: mantenimiento_permiso
  ) {
    return await ssmHttpService.delete(
      API.mantenimiento_permiso + "/" + mantenimiento_permiso.id,
      null,
      false
    );
  }

  @Mutation
  public onGetmantenimiento_permisos(res: mantenimiento_permiso[]) {
    this.mantenimiento_permisos = res
      ? res.map((x) => new mantenimiento_permiso(x))
      : [];
  }

  @Mutation
  public onGetmantenimiento_permiso(res: mantenimiento_permiso) {
    this.mantenimiento_permiso = new mantenimiento_permiso(res);
  }
}
export default getModule(mantenimiento_permisoModule);
